// File generated from our OpenAPI spec
export const ApiVersion = '2023-10-16';
